export const routes = [
  {
    path: '/:all(.*)',
    name: '/[...all]',
    component: () => import('/opt/buildhome/repo/src/pages/[...all].vue'),
    /* no children */
  },
  {
    path: '/admin-users',
    name: '/admin-users',
    component: () => import('/opt/buildhome/repo/src/pages/admin-users.vue'),
    /* no children */
    meta: {
      "layout": "default"
    },
  },
  {
    path: '/announcements',
    /* internal name: '/announcements' */
    /* no component */
    children: [
      {
        path: '',
        name: '/announcements/',
        component: () => import('/opt/buildhome/repo/src/pages/announcements/index.vue'),
        /* no children */
        meta: {
          "layout": "default"
        },
      }
    ],
  },
  {
    path: '/authentication',
    name: '/authentication',
    component: () => import('/opt/buildhome/repo/src/pages/authentication.vue'),
    /* no children */
    meta: {
      "layout": "default"
    },
  },
  {
    path: '/avatar-access',
    name: '/avatar-access',
    component: () => import('/opt/buildhome/repo/src/pages/avatar-access.vue'),
    /* no children */
    meta: {
      "layout": "default"
    },
  },
  {
    path: '/avatar-applies',
    name: '/avatar-applies',
    component: () => import('/opt/buildhome/repo/src/pages/avatar-applies.vue'),
    /* no children */
    meta: {
      "layout": "default"
    },
  },
  {
    path: '/avatar-lists',
    name: '/avatar-lists',
    component: () => import('/opt/buildhome/repo/src/pages/avatar-lists.vue'),
    /* no children */
    meta: {
      "layout": "default"
    },
  },
  {
    path: '/avatar-pipelines',
    name: '/avatar-pipelines',
    component: () => import('/opt/buildhome/repo/src/pages/avatar-pipelines.vue'),
    /* no children */
    meta: {
      "layout": "default"
    },
  },
  {
    path: '/avatar-unit-packages',
    name: '/avatar-unit-packages',
    component: () => import('/opt/buildhome/repo/src/pages/avatar-unit-packages.vue'),
    /* no children */
    meta: {
      "layout": "default"
    },
  },
  {
    path: '/billing-plans',
    name: '/billing-plans',
    component: () => import('/opt/buildhome/repo/src/pages/billing-plans.vue'),
    /* no children */
    meta: {
      "layout": "default"
    },
  },
  {
    path: '/chats',
    /* internal name: '/chats' */
    /* no component */
    children: [
      {
        path: '',
        name: '/chats/',
        component: () => import('/opt/buildhome/repo/src/pages/chats/index.vue'),
        /* no children */
        meta: {
          "layout": "default"
        },
      },
      {
        path: ':id',
        name: '/chats/[id]',
        component: () => import('/opt/buildhome/repo/src/pages/chats/[id].vue'),
        /* no children */
        meta: {
          "layout": "default"
        },
      }
    ],
  },
  {
    path: '/configs',
    name: '/configs',
    component: () => import('/opt/buildhome/repo/src/pages/configs.vue'),
    /* no children */
    meta: {
      "layout": "default"
    },
  },
  {
    path: '/creation-transactions',
    name: '/creation-transactions',
    component: () => import('/opt/buildhome/repo/src/pages/creation-transactions.vue'),
    /* no children */
    meta: {
      "layout": "default"
    },
  },
  {
    path: '/credit-packages',
    name: '/credit-packages',
    component: () => import('/opt/buildhome/repo/src/pages/credit-packages.vue'),
    /* no children */
    meta: {
      "layout": "default"
    },
  },
  {
    path: '/credit-transactions',
    name: '/credit-transactions',
    component: () => import('/opt/buildhome/repo/src/pages/credit-transactions.vue'),
    /* no children */
    meta: {
      "layout": "default"
    },
  },
  {
    path: '/driven-stats',
    /* internal name: '/driven-stats' */
    /* no component */
    children: [
      {
        path: '',
        name: '/driven-stats/',
        component: () => import('/opt/buildhome/repo/src/pages/driven-stats/index.vue'),
        /* no children */
        meta: {
          "layout": "default"
        },
      },
      {
        path: 'overview',
        name: '/driven-stats/overview',
        component: () => import('/opt/buildhome/repo/src/pages/driven-stats/overview.vue'),
        /* no children */
        meta: {
          "layout": "default"
        },
      },
      {
        path: 'ranking',
        name: '/driven-stats/ranking',
        component: () => import('/opt/buildhome/repo/src/pages/driven-stats/ranking.vue'),
        /* no children */
        meta: {
          "layout": "default"
        },
      },
      {
        path: 'realtime',
        name: '/driven-stats/realtime',
        component: () => import('/opt/buildhome/repo/src/pages/driven-stats/realtime.vue'),
        /* no children */
        meta: {
          "layout": "default"
        },
      }
    ],
  },
  {
    path: '/emails',
    /* internal name: '/emails' */
    /* no component */
    children: [
      {
        path: '',
        name: '/emails/',
        component: () => import('/opt/buildhome/repo/src/pages/emails/index.vue'),
        /* no children */
        meta: {
          "layout": "default"
        },
      }
    ],
  },
  {
    path: '/feedback',
    /* internal name: '/feedback' */
    /* no component */
    children: [
      {
        path: '',
        name: '/feedback/',
        component: () => import('/opt/buildhome/repo/src/pages/feedback/index.vue'),
        /* no children */
        meta: {
          "layout": "default"
        },
      },
      {
        path: ':id',
        name: '/feedback/[id]',
        component: () => import('/opt/buildhome/repo/src/pages/feedback/[id].vue'),
        /* no children */
        meta: {
          "layout": "default"
        },
      }
    ],
  },
  {
    path: '/iframe-versions',
    name: '/iframe-versions',
    component: () => import('/opt/buildhome/repo/src/pages/iframe-versions.vue'),
    /* no children */
    meta: {
      "layout": "default"
    },
  },
  {
    path: '/login',
    name: '/login',
    component: () => import('/opt/buildhome/repo/src/pages/login.vue'),
    /* no children */
    meta: {
      "layout": "auth",
      "public": true
    },
  },
  {
    path: '/notifications',
    /* internal name: '/notifications' */
    /* no component */
    children: [
      {
        path: '',
        name: '/notifications/',
        component: () => import('/opt/buildhome/repo/src/pages/notifications/index.vue'),
        /* no children */
        meta: {
          "layout": "default"
        },
      }
    ],
  },
  {
    path: '/open-api-policies',
    name: '/open-api-policies',
    component: () => import('/opt/buildhome/repo/src/pages/open-api-policies.vue'),
    /* no children */
    meta: {
      "layout": "default"
    },
  },
  {
    path: '/public-avatars',
    name: '/public-avatars',
    component: () => import('/opt/buildhome/repo/src/pages/public-avatars.vue'),
    /* no children */
    meta: {
      "layout": "default"
    },
  },
  {
    path: '/studio-voice-agent',
    name: '/studio-voice-agent',
    component: () => import('/opt/buildhome/repo/src/pages/studio-voice-agent.vue'),
    /* no children */
    meta: {
      "layout": "default"
    },
  },
  {
    path: '/user-characters',
    name: '/user-characters',
    component: () => import('/opt/buildhome/repo/src/pages/user-characters.vue'),
    /* no children */
    meta: {
      "layout": "default"
    },
  },
  {
    path: '/users',
    name: '/users',
    component: () => import('/opt/buildhome/repo/src/pages/users.vue'),
    /* no children */
    meta: {
      "layout": "default"
    },
  },
  {
    path: '/vendors',
    name: '/vendors',
    component: () => import('/opt/buildhome/repo/src/pages/vendors.vue'),
    /* no children */
    meta: {
      "layout": "default"
    },
  }
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

